import { render, staticRenderFns } from "./AssessmentStudentsView.vue?vue&type=template&id=6e1bda46&scoped=true"
import script from "./AssessmentStudentsView.vue?vue&type=script&lang=js"
export * from "./AssessmentStudentsView.vue?vue&type=script&lang=js"
import style0 from "./AssessmentStudentsView.vue?vue&type=style&index=0&id=6e1bda46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1bda46",
  null
  
)

export default component.exports